<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                Potwierdź
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        Czy na pewno chcesz otwozyć wybraną szafkę?
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="dialogRef.close()"
                aria-label="Cancel">
            {{'Cancel'|translate}}
        </button>
        <button
                mat-button
                class="mr-8"
                (click)="dialogRef.close('confirm-open')"
                aria-label="Confirm">
            {{'Confirm'|translate}}
        </button>

    </div>
</div>
